// accessToken 만료시간
export const JWT_EXPIRY_TIME = 2 * 60 * 60 * 1000;
